export enum PROPOSAL_STATUS_TRANSLATION {
	BankPreparingFiduciaryLienContract,
	BankPreparingFinancingContract,
	BankPreparingFinancingContractByTable,
	BankReanalyzingDocumentsSent,
	BankReviewingDocumentsForLegalAnalysis,
	BankReviewingInformationToPrepareFinancingContract,
	BankWaitingCaixaForReleaseFGTS,
	BankWaitingConfirmationFinancingAmountsByBuyer,
	BankWaitingFinancingContractSignedByAllParties,
	BankWaitingFiduciaryLienContractSignedByAllParties,
	BankWaitingForDocumentsCreditAnalysis,
	BankWaitingForDocumentsLegalAnalysis,
	BankWaitingForPendingDocumentsLegalAnalysis,
	BankWaitingForResentDocumentsLegalAnalysis,
	BankWaitingInterbankPayment,
	CreditAnalysisBlockedDueToIssues,
	CreditAnalysisInProgress,
	CreditApproved,
	CreditApprovedWithConditions,
	CreditRefused,
	FinancingContractIssueFound,
	FinancingContractSigned,
	FinancingProcessBlocked,
	FinancingProcessCompleted,
	LegalAnalysisInProgress,
	LegalAnalysisInProgressByTable,
	LegalAnalysisIssueFound,
	LegalChecklistCompleted,
	LegalChecklistIssuesFound,
	ProposalCancelled,
	ProposalExpired,
	ProposalNotStarted,
	ProposalRejected,
	RegistrationFinancingContractApproved,
	TableReviewingDocumentsForLegalAnalysis,
	WaitingForReleaseResources,
	WaitingRegistrationFinancingContractNotaryOffice,
	WaitingValidationFinancingContractRegistrationByBank,
	WaitingValidationFinancingContractRegistrationNotaryOffice,
	InspectionOngoing
}
